import * as actionTypes from '../actionTypes';

const typeAheadReducer = (state = { addresses: [], units: [], isUnitsNeeded: false }, action) => {
  switch (action?.type) {
    case actionTypes.UPDATE_ADDRESS_TYPEAHEAD:
      return {
        ...state,
        addresses: action?.data || [],
        units: [],
        isUnitsNeeded: false,
      };

    case actionTypes.ADDRESS_TYPEAHEAD_RESET:
      return {
        ...state,
        addresses: [],
        units: [],
        isUnitsNeeded: false,
      };

    case actionTypes.UPDATE_UNITS_TYPEAHEAD:
      return {
        ...state,
        units: action?.data || [],
        isUnitsNeeded: !!action?.data?.length,
      };

    default:
      return state;
  }
};

export default typeAheadReducer;
